import { SwitchOptionTheme } from '../../types';

export const SWITCHOPTION_DEFAULT_THEME: SwitchOptionTheme = {
    groupRadius: 10,
    padding: {
        x: 16,
        y: 20,
    },
    borderWidth: {
        default: 1,
        checked: 3,
    },
    borderColor: {
        default: 'border',
        checked: 'primary.base',
    },
};
